var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container order-list" },
    [
      _c("breadcrumb", { attrs: { breadcrumbConfig: _vm.breadcrumbConfig } }),
      _c("div", { staticClass: "content" }, [
        _c("h2", { staticClass: "padding" }, [_vm._v("运营订单")]),
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "searchForm",
                staticClass: "search-form",
                attrs: {
                  inline: true,
                  id: "searchForm",
                  model: _vm.searchForm,
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "订单编号", prop: "orderNo" } },
                  [
                    _c("el-input", {
                      attrs: {
                        size: "small",
                        placeholder: "请输入订单编号",
                        oninput: "value=value.replace(/[^0-9.]/g,'')",
                        filterable: "",
                        clearable: "",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.fetchData("search")
                        },
                      },
                      model: {
                        value: _vm.searchForm.orderNo,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.searchForm,
                            "orderNo",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "searchForm.orderNo",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "收货人信息", prop: "postUserInfo" } },
                  [
                    _c("el-input", {
                      attrs: {
                        size: "small",
                        placeholder: "收货人信息",
                        clearable: "",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.fetchData("search")
                        },
                      },
                      model: {
                        value: _vm.searchForm.postUserInfo,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.searchForm,
                            "postUserInfo",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "searchForm.postUserInfo",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "公司部门", prop: "orgCode" } },
                  [
                    _c("el-cascader", {
                      attrs: {
                        options: _vm.orgCodeList,
                        placeholder: "请选择公司部门",
                        size: "small",
                        "show-all-levels": false,
                        props: {
                          label: "orgName",
                          value: "orgCode",
                          checkStrictly: true,
                        },
                        filterable: "",
                        clearable: "",
                      },
                      on: { change: _vm.onChangeCategory },
                      model: {
                        value: _vm.searchForm.orgCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "orgCode", $$v)
                        },
                        expression: "searchForm.orgCode",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "业绩归属人", prop: "achievementUserId" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择跟进客服",
                          size: "small",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.achievementUserId,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "achievementUserId", $$v)
                          },
                          expression: "searchForm.achievementUserId",
                        },
                      },
                      _vm._l(_vm.salesAuthority, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.reallyName, value: item.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                false
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "类目跟进人", prop: "postUserInfo" } },
                      [
                        _c("el-input", {
                          attrs: {
                            size: "small",
                            placeholder: "类目跟进人信息",
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.fetchData("search")
                            },
                          },
                          model: {
                            value: _vm.searchForm.postUserInfo,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "postUserInfo", $$v)
                            },
                            expression: "searchForm.postUserInfo",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  { attrs: { label: "订单类型", prop: "orderType" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择订单类型",
                          size: "small",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.orderType,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "orderType", $$v)
                          },
                          expression: "searchForm.orderType",
                        },
                      },
                      _vm._l(_vm.dictionaries.order_main_type, function (item) {
                        return _c("el-option", {
                          key: item.dictId,
                          attrs: { label: item.dictName, value: item.dictId },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "提交时间", prop: "createdTime" } },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        type: "daterange",
                        size: "small",
                        format: "yyyy-MM-dd",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "default-time": ["00:00:00", "23:59:59"],
                      },
                      on: { change: _vm.onChangeTime },
                      model: {
                        value: _vm.searchForm.createdTime,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "createdTime", $$v)
                        },
                        expression: "searchForm.createdTime",
                      },
                    }),
                  ],
                  1
                ),
                _vm.afterSale == "afterSale"
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "商品状态", prop: "itemStatus" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "请选择商品状态",
                              size: "small",
                              filterable: "",
                              clearable: "",
                            },
                            model: {
                              value: _vm.searchForm.itemStatus,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "itemStatus", $$v)
                              },
                              expression: "searchForm.itemStatus",
                            },
                          },
                          _vm._l(
                            _vm.dictionaries.after_sale_subset_status,
                            function (item) {
                              return _c("el-option", {
                                key: item.dictId,
                                attrs: {
                                  label: item.dictName,
                                  value: item.dictId,
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  { attrs: { label: "订单来源", prop: "orderOrigin" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择订单来源",
                          size: "small",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.orderOrigin,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "orderOrigin", $$v)
                          },
                          expression: "searchForm.orderOrigin",
                        },
                      },
                      _vm._l(_vm.dictionaries.jh_order_origin, function (item) {
                        return _c("el-option", {
                          key: item.dictId,
                          attrs: { label: item.dictName, value: item.dictId },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("search")
                          },
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.fetchData("search")
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("reset")
                          },
                        },
                      },
                      [_vm._v("重置 ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h3", [_vm._v("数据列表")]),
          _c("div", { staticClass: "btn-list tabclass" }, [
            _c(
              "div",
              {},
              [
                _c(
                  "el-button",
                  {
                    staticClass: "tabBtn",
                    attrs: {
                      plain: "",
                      disabled: _vm.loading,
                      type:
                        _vm.currentTab == _vm.currentTabStatus.all
                          ? "primary"
                          : "info",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onChangeCurrentTab(_vm.currentTabStatus.all)
                      },
                    },
                  },
                  [_vm._v("全部 ")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "tabBtn",
                    attrs: {
                      plain: "",
                      disabled: _vm.loading,
                      type:
                        _vm.currentTab == _vm.currentTabStatus.beforePay
                          ? "primary"
                          : "info",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onChangeCurrentTab(
                          _vm.currentTabStatus.beforePay
                        )
                      },
                    },
                  },
                  [_vm._v("待支付 ")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "tabBtn",
                    attrs: {
                      plain: "",
                      disabled: _vm.loading,
                      type:
                        _vm.currentTab == _vm.currentTabStatus.choicing
                          ? "primary"
                          : "info",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onChangeCurrentTab(
                          _vm.currentTabStatus.choicing
                        )
                      },
                    },
                  },
                  [_vm._v("发货前 ")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "tabBtn",
                    attrs: {
                      plain: "",
                      disabled: _vm.loading,
                      type:
                        _vm.currentTab == _vm.currentTabStatus.signFor
                          ? "primary"
                          : "info",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onChangeCurrentTab(
                          _vm.currentTabStatus.signFor
                        )
                      },
                    },
                  },
                  [_vm._v("待签收 ")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "tabBtn",
                    attrs: {
                      plain: "",
                      disabled: _vm.loading,
                      type:
                        _vm.currentTab == _vm.currentTabStatus.accomplish
                          ? "primary"
                          : "info",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onChangeCurrentTab(
                          _vm.currentTabStatus.accomplish
                        )
                      },
                    },
                  },
                  [_vm._v("已完成 ")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "tabBtn",
                    attrs: {
                      plain: "",
                      disabled: _vm.loading,
                      type:
                        _vm.currentTab == _vm.currentTabStatus.afterSale
                          ? "primary"
                          : "info",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onChangeCurrentTab(
                          _vm.currentTabStatus.afterSale
                        )
                      },
                    },
                  },
                  [_vm._v("售后单 ")]
                ),
              ],
              1
            ),
            _c(
              "div",
              [
                _vm.parArray.indexOf("neworder_operationOrder_export") != -1 &&
                _vm.currentTab != _vm.currentTabStatus.beforePay
                  ? _c(
                      "el-button",
                      {
                        staticClass: "blueBtn",
                        attrs: { loading: _vm.exportLoading, type: "primary" },
                        on: { click: _vm.afterExport },
                      },
                      [_vm._v("导出")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c("orders-list-table", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: {
              dataList: _vm.page.list,
              heightStr: _vm.columns.height,
              afterSale: _vm.afterSale,
              typeStr: _vm.columns.type,
              config: _vm.columns.config,
              sortObj: _vm.columns.sortObj,
            },
            on: {
              onTableShowDialogCom: _vm.resTableShowDialog,
              outTableCancelOrderMsg: _vm.onCancelOrderMsg,
              tableSelectionChange: _vm.handleSelectionChange,
            },
          }),
          _c(
            "div",
            { staticClass: "page" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.page.pageNo,
                  "page-sizes": [3, 5, 10, 20, 50],
                  "page-size": _vm.page.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.page.totalNum,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            width: _vm.dialog.width,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _vm.dialog.type === "modifyOrderNoOne"
            ? [
                _c("modify-order-no", {
                  ref: "modifyOrderNo",
                  attrs: {
                    orderObj: _vm.dialog.row,
                    type: _vm.dialog.type,
                    source: "service",
                  },
                  on: { submitState: _vm.modifyState },
                }),
              ]
            : _vm._e(),
          _vm.dialog.type === "logisticsMessageOne"
            ? [
                _c("step-progress", {
                  attrs: {
                    orderObj: _vm.dialog.row,
                    type: "logisticsMessageOne",
                  },
                }),
              ]
            : _vm._e(),
          _vm.dialog.type === "shenheStep"
            ? [
                _c("step-progress", {
                  attrs: {
                    orderObj: _vm.dialog.row,
                    processFunc: _vm.dictionaries.process_func,
                    type: "shenheStep",
                  },
                }),
              ]
            : _vm._e(),
          _vm.dialog.type === "transparent"
            ? [
                _c(
                  "div",
                  [
                    _c("upload-file", {
                      ref: "transparent",
                      on: { dialogVisible: _vm.closeDialog },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type === "closeOrder"
            ? [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.setCloseOrder,
                      callback: function ($$v) {
                        _vm.setCloseOrder = $$v
                      },
                      expression: "setCloseOrder",
                    },
                  },
                  _vm._l(
                    _vm.dictionaries.order_main_close_reason,
                    function (item, index) {
                      return _c(
                        "el-radio",
                        {
                          key: index,
                          staticClass: "setPay_payment",
                          attrs: { label: item.dictId },
                        },
                        [_vm._v(_vm._s(item.dictName) + " ")]
                      )
                    }
                  ),
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialogBtnright dialogBtnright_right",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_quxiao",
                        on: {
                          click: function ($event) {
                            _vm.dialog.visible = false
                          },
                        },
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_queren",
                        attrs: { type: "primary" },
                        on: { click: _vm.handlerCloseOrderSubmit },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type === "modifyOrderNoOne" ||
          _vm.dialog.type === "transparent"
            ? _c(
                "div",
                { staticClass: "dialog-btn" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "setPay_payment_btn_quxiao",
                      attrs: { type: "primary", plain: "" },
                      on: {
                        click: function ($event) {
                          _vm.closeDialog()
                          _vm.$refs.transparent.$refs.uploadFileXls.clearFiles()
                        },
                      },
                    },
                    [_vm._v("取消 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "setPay_payment_btn_queren",
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.actionDialog()
                          _vm.$refs.transparent.$refs.uploadFileXls.clearFiles()
                        },
                      },
                    },
                    [_vm._v("确认 ")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }